import script from "./Activity_CreateClass.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_CreateClass.vue?vue&type=script&setup=true&lang=js"

import "./Activity_CreateClass.vue?vue&type=style&index=0&id=386917d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-386917d6"]])

export default __exports__